import { TagResource } from '../resources';
import { ImsObject } from './ims_object';

export const IMS_TYPE__TAG = 'tag';

export class Tag extends ImsObject {
    show;

    constructor(resource = new TagResource()) {
        super(IMS_TYPE__TAG, resource);
        this.show = true;
    }

    get id() {
        return this.resource.id;
    }

    set id(value) {
        this.resource.id = value;
    }

    get name() {
        return this.resource.name;
    }

    set name(value) {
        this.resource.name = value;
    }

    get siteId() {
        return this.resource.site_id;
    }

    set siteId(value) {
        this.resource.site_id = value;
    }

    get isDeleted() {
        return this.resource.is_deleted;
    }
}
